export const setRequestInfo = (
	requestInfo: Redux.RequestInfo,
): RequestInfoNS.SetRequestInfo => ({
	type: 'SET_REQUEST_INFO',
	payload: requestInfo,
});
